import styled, {css} from "styled-components"
import {greys} from "@irati/ui/src/global/colors"

const spacing = css`
  padding: 10px;
  flex-grow: 2;
  text-align: center;
  line-height: 18px;
`
const Minus = styled.span`
  border-right: 1px solid ${greys.mediumDark};
  cursor: pointer;
  ${spacing}
`

const Plus = styled.span`
  border-left: 1px solid ${greys.mediumDark};
  font-weight: ${(props) => (props.disabled ? "normal" : "bold")};
  cursor: pointer;
  ${(props) => {
    if (props.disabled) {
      return `
          background-color: ${greys.disabled};
          cursor: not-allowed;
      `
    }
  }}
  ${spacing}
  `

const Quantity = styled.span`
  ${(props) => (props.bold ? "font-weight: bold;" : "")}
  ${spacing}
  `

export {
  Plus,
  Minus,
  Quantity
}
